module.exports = __webpack_public_path__ + "img/power.10fd085d.svg";